import React from 'react';
import { IAppliedFilter } from './filters';
import { FilterCard } from './FilterCard';
import styles from './AppliedFilters.module.scss';
import classnames from 'classnames';
import { AppliedFilterDescription } from './AppliedFilterDescription/AppliedFilterDescription';

interface IAppliedFilterProps {
  filters: IAppliedFilter[];
  onAppliedFiltersChanged: (newAppliedFilters: IAppliedFilter[]) => void;
  onAddAnotherFilterClicked: () => void;
}

export function getAppliedFilterKey(filter: IAppliedFilter) {
  return `${filter.field.name}_${filter.field.type}_${filter.operation}_${filter.value}`;
}

export const AppliedFilters = ({
  filters,
  onAppliedFiltersChanged,
  onAddAnotherFilterClicked,
}: IAppliedFilterProps) => {
  const handleDeleteFilter = (filter: IAppliedFilter) => {
    const index = filters.indexOf(filter);
    if (index === -1) return;
    const newFilters = [...filters];
    newFilters.splice(index, 1);
    onAppliedFiltersChanged(newFilters);
  };

  return (
    <div className={classnames(styles.content, 'nomadScrollbar1')}>
      <div className={styles.list}>
        {filters.map((appliedFilter) => {
          const filterKey = getAppliedFilterKey(appliedFilter);
          return (
            <FilterCard
              key={filterKey}
              onDeleteFilter={handleDeleteFilter}
              appliedFilter={appliedFilter}
              dataTestId={filterKey}
            >
              <AppliedFilterDescription filter={appliedFilter} />
            </FilterCard>
          );
        })}

        <button
          className={styles.addAnother}
          onClick={onAddAnotherFilterClicked}
        >
          + Add another advanced filter
        </button>
      </div>
    </div>
  );
};
